export const getQueryVariable = (variable, location = window.location) => {
  if (location.search) {
    let searchParams = new URLSearchParams(location.search);
    return searchParams.get(variable);
  }
  return null;
};
export const setQueryVariable = (variable, val, location = window.location) => {
  let newSearch = location.search;
  if (newSearch) {
    let searchParams = new URLSearchParams(newSearch);
    searchParams.set(variable, val);
    newSearch = `?${searchParams.toString()}`;
  } else {
    newSearch = `?${variable}=${val}`;
  }
  return location.pathname + newSearch;
};
export const deleteQueryVariable = (variable, location = window.location) => {
  let newSearch = location.search;
  if (newSearch) {
    let searchParams = new URLSearchParams(newSearch);
    searchParams.delete(variable);
    newSearch = `?${searchParams.toString()}`;
  } else {
    newSearch = "";
  }
  return location.pathname + newSearch;
};
